import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import useSpending from '../../../features/spending/hooks/useSpending'
import SingleSpendingDemand from '../../../features/spendingDemand/components/SingleSpendingDemand'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'
import TextBox from '../../../components/molecules/TextBox/TextBox'
import SpendingListPresenter from '../../../features/spendingDemand/components/SpendingList/SpendingListPresenter'
import { SpendingDemandCreditListPresenter } from '../../../features/spendingDemand/components/CreditList'
import { useSingleSpendingDemand, useSpendingDemandSpendingList, useSpendingDemandSubCreditList } from '../../../features/spendingDemand/hooks'
import { numberToStingWithSpaces } from '../../../utils/numberDisplayer'
import SpendingDemandNavigator from '../../../features/spendingDemand/components/SpendingDemandNavigator/SpendingDemandNavigator'
import { buildSpendingDemandListLink } from '../../../features/spendingDemand/utils/spendingDemandListNavigation'


function SingleSpendingDemandUserPageContent() {
  const {spendingDemandId} = useParams()
  const { search } = useLocation()
  // Retour à la liste d'origine, à la page atteinte avec les flèches
  const backToListLink = buildSpendingDemandListLink('/spending_demand_user', search)

  const {fetchAndStoreSingleSpendingAndSingleSpendingDemand } = useSpending()
  const {singleSpendingDemandData: singleSpending} = useSingleSpendingDemand()
  
  const spendingDemandIdForHooks = singleSpending?.spending_demand_id || spendingDemandId || ''
  
  const { getAllQuery: spendingQuery, totalSpending } = useSpendingDemandSpendingList(spendingDemandIdForHooks, {
    disableQuery: !spendingDemandIdForHooks
  })
  


  const { getAllQuery: subCreditQuery } = useSpendingDemandSubCreditList(spendingDemandIdForHooks, {
    disableQuery: !spendingDemandIdForHooks
  })

  const hasSpendings = !spendingQuery.isLoading && spendingQuery.data?.data && spendingQuery.data.data.length > 0

  const spendingCount = spendingQuery.data?.data?.length || 0
  const spendingTotalTTC = totalSpending?.totalTTC || 0
  const spendingTotalFormatted = spendingTotalTTC > 0 ? numberToStingWithSpaces(spendingTotalTTC) + ' FCFA' : ''

  useEffect(() => {
    if(spendingDemandId)
     fetchAndStoreSingleSpendingAndSingleSpendingDemand(spendingDemandId, true)
  },[]) // eslint-disable-line
  return (
    <SpendingDemandNavigator basePath="/spending_demand_user">
    <PageLayout 
      title="Détail de la demande de dépense"
      showBackButton
      backButtonLinkToIfNoHistory="/spending_demand_user"
      backButtonTo={backToListLink}
      backButtonReplace
    >
      <div>
     <SingleSpendingDemand.GeneralInfo/>
     <TextBox
      content={[
        {
          title: "Justificatifs",
          ItemRender : () => (
            <SingleSpendingDemand.FilesList/>
          )
        }
      ]}/>

      {!subCreditQuery.isLoading && subCreditQuery.data?.data && subCreditQuery.data.data.length > 1 && (
        <SpendingDemandCreditListPresenter />
      )}
    
      {hasSpendings && (
        <>
          <div style={{ height: "20px" }}/>
          <TextBox
            colorStyle={{backgroundColor: "#f5f5f58a"}} 
            content={[
              {
                title: `${spendingCount} ${spendingCount > 1 ? 'dépenses' : 'dépense'} réelle${spendingCount > 1 ? 's' : ''} associée${spendingCount > 1 ? 's' : ''} à cette demande${spendingTotalFormatted ? ` - Total: ${spendingTotalFormatted}` : ''}`,
                ItemRender : () => (
                  <SpendingListPresenter />
                )
              }
            ]}/>
        </>
      )}
     

     
     <div style={{display: "flex", gap: "10px", marginTop: "10px", marginBottom: "10px"}}>


     </div>
     </div>
     <div>
     <div style={{display: "flex", gap: "10px"}}>
      <SingleSpendingDemand.ActionBtnSpending usertype="user" />
     </div>

     </div>
    </PageLayout>
    </SpendingDemandNavigator>
  )
}

// Remonte la page à chaque changement de demande (navigation précédente / suivante)
export default function SingleSpendingDemandUserPage() {
  const {spendingDemandId} = useParams()
  return <SingleSpendingDemandUserPageContent key={spendingDemandId} />
}
